import {
	Autocomplete,
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	ThemeProvider,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { useEffect, useState } from "react";
import { getMaterias } from "../../../services/MateriaService.js";
import { getFueros } from "../../../services/FueroService.js";
import { getTiposVinculos } from "../../../services/TipoVinculoService.js";
import MateriaTipoVinculoDialog from "./MateriaTipoVinculoDialog.jsx";
import { getProcesos } from "../../../services/ProcesoService.js";
import { getMateriasTipoVinculos, getMateriaTipoVinculo } from "../../../services/MateriaTipoVinculoService.js";
import Message from "../../../utils/Message.jsx";
import { Box } from "@mui/system";
import React from 'react';


const initialState = {
	orden: "ASC",
	ordenarPor: "descripcion_fuero",
	rows: 0,
	first: 0,
};

const ordenOptions = [
	{
		id: "ASC",
		descripcion: "Ascendente",
	},
	{
		id: "DESC",
		descripcion: "Descendente",
	},
];

const ordenarPorOptions = [
	{
		id: "descripcion_fuero",
		descripcion: "Fuero",
	},
	{
		id: "descripcion_proceso",
		descripcion: "Proceso",
	},
	{
		id: "descripcion_materia",
		descripcion: "Materia",
	},
	{
		id: "descripcion_tipo_vinculo",
		descripcion: "Tipo Vínculo",
	},
];

const nameItemsText = "Materias - Tipos Vínculos";
//
// ##################################################################################################################### 
//
const MateriaTipoVinculoTable = ({ ...data }) => {
	const [searchData, setSearchData] = useState(initialState);
	const [itemsCrud, setItemsCrud] = useState([]);
	const [itemCrud, setItemCrud] = useState({});
	const [actionCrud, setActionCrud] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [openDialog, setOpenDialog] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [fueros, setFueros] = useState([]);
	const [valueAutoCompleteFuero, setValueAutoCompleteFuero] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteFuero, setInputValueAutoCompleteFuero] = useState("");
	const [procesos, setProcesos] = useState([]);
	const [valueAutoCompleteProceso, setValueAutoCompleteProceso] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteProceso, setInputValueAutoCompleteProceso] = useState("");
	const [materias, setMaterias] = useState([]);
	const [valueAutoCompleteMateria, setValueAutoCompleteMateria] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteMateria, setInputValueAutoCompleteMateria] = useState("");
	const [tipoVinculos, setTipoVinculos] = useState([]);
	const [valueAutoCompleteTipoVinculo, setValueAutoCompleteTipoVinculo] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteTipoVinculo, setInputValueAutoCompleteTipoVinculo] = useState("");




	const tableColumns = [
		{
			name: "id",
			label: "ID",
			options: {
				display: "excluded",
			},
		},
		{
			name: "descripcion_fuero",
			label: "Fuero",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoFuero = itemsCrud[tableMeta.rowIndex].habilitado_fuero ? "" : "(Deshabilitado)";
					return `${value} ${habilitadoFuero}`;
				},
			},
		},
		{
			name: "descripcion_proceso",
			label: "Proceso",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoProceso = itemsCrud[tableMeta.rowIndex].habilitado_proceso ? "" : "Deshabilitado";
					return `${value} ${habilitadoProceso}`;
				},
			},
		},
		{
			name: "descripcion_materia",
			label: "Materia",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoMateria = itemsCrud[tableMeta.rowIndex].habilitado_materia ? "" : "(Deshabilitada)";
					return `${value} ${habilitadoMateria}`;
				},
			},
		},
		{
			name: "descripcion_tipo_vinculo",
			label: "Tipo Vínculo",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoTipoVinculo = itemsCrud[tableMeta.rowIndex].habilitado_tipo_vinculo ? "" : "(Deshabilitado)";
					return `${value} ${habilitadoTipoVinculo}`;
				},
			},
		},
		{
			name: "actions",
			label: "Acciones",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => (
					<>

						<Tooltip title="Deshabilitar">
							<IconButton
								size="small"
								aria-label="disable"
								onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "disable")}
							>
								<RemoveIcon />
							</IconButton>
						</Tooltip>

						<Tooltip title="Ver">
							<IconButton
								size="small"
								aria-label="read"
								onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "read")}
							>
								<ZoomInIcon />
							</IconButton>
						</Tooltip>

					</>
				),
			},
		},
	];

	const tableOptions = {
		storageKey: "my-table-state",
		rowsPerPageOptions: [10, 20, 30],
		serverSide: true,
		count: totalRowsCount,
		rowsPerPage: rowsPerPage,
		onChangeRowsPerPage: (numberOfRows) => {
			setRowsPerPage(numberOfRows);
		},
		onChangePage: (currentPage) => {
			setCurrentPage(currentPage);
		},
		download: false,
		filter: false,
		print: false,
		search: false,
		viewColumns: false,
		selectableRowsHeader: false,
		selectableRows: "none",
		elevation: 1,
		textLabels: {
			body: {
				noMatch: "No se han encontrado resultados para esta búsqueda",
			},
			pagination: {
				next: "Próxima",
				previous: "Previa",
				rowsPerPage: "Filas:",
				displayRows: "de",
			},
		},
	};

	//
	// ################################################################################
	//

	const load = async () => {
		searchData.rows = rowsPerPage;
		searchData.first = currentPage * rowsPerPage;
		searchData.sortField = searchData.ordenarPor;
		searchData.sortOrder = searchData.orden;



		setIsDoingSomething(true);
		const response = await getMateriasTipoVinculos(searchData);
		setIsDoingSomething(false);


		if (response.ok) {
			setItemsCrud(response.data.data);
			setTotalRowsCount(response.data.count);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//
	useEffect(() => {
		const loadFueros = async () => {
			setIsDoingSomething(true);
			const response = await getFueros({ estado: "habilitado" });
			setIsDoingSomething(false);

			if (response.ok) {
				let _response = response.data.data;
				let _Fueros = [];

				_response.forEach((item) => {
					_Fueros.push({
						id: item.id,
						label: item.descripcion,
					});
				});

				setFueros(_Fueros);
			} else {
				setFueros([]);
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};
		loadFueros();
	}, []);


	//
	// ################################################################################
	//

	const loadMaterias = async (newValue) => {
		let _params = {
			idProceso: newValue?.id || valueAutoCompleteProceso?.id,
			idMateria: newValue?.id,
			estado: searchData.estado,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};
		setIsDoingSomething(true);
		const response = await getMaterias(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _Materias = [];
			_response.forEach((item) => {
				_Materias.push({
					id: item.id,
					id_proceso: item.id_proceso,
					label: item.descripcion,
				});
			});

			setMaterias(_Materias);
		} else {
			setMaterias([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//

	useEffect(() => {
		const loadTipoVinculos = async () => {
			setIsDoingSomething(true);
			const response = await getTiposVinculos({ estado: "todos" });
			setIsDoingSomething(false);

			if (response.ok) {
				let _response = response.data.data;
				let _TipoVinculos = [];

				_response.forEach((item) => {
					_TipoVinculos.push({
						id: item.id,
						label: item.descripcion,
					});
				});

				setTipoVinculos(_TipoVinculos);
			} else {
				setTipoVinculos([]);
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};
		loadTipoVinculos();
	}, []);
	//
	// ################################################################################
	//

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage, rowsPerPage]);

	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};

	const handleFueroChange = (event, newValue) => {
		setValueAutoCompleteFuero(newValue);
		setSearchData({
			...searchData,
			idFuero: newValue?.id || '',
		});
		loadProcesos(newValue);
	};

	const handleProcesoChange = (event, newValue) => {
		setValueAutoCompleteProceso(newValue);
		setSearchData({
			...searchData,
			idProceso: newValue?.id || '',
		});
		loadMaterias(newValue);
	};

	const search = () => {
		setCurrentPage(0);
		load();
	};

	const clean = () => {
		setValueAutoCompleteFuero({ label: "", id: "" });
		setValueAutoCompleteProceso({ label: "", id: "" });
		setValueAutoCompleteMateria({ label: "", id: "" });
		setValueAutoCompleteTipoVinculo({ label: "", id: "" });
		setSearchData(initialState);
		setItemsCrud([]);
		setCurrentPage(0);
		setTotalRowsCount(0);
	};

	const handleClickActionCrud = (itemCrud, action) => {
		let _itemCrud = {};

		if (action !== "create") {
			const loadItem = async () => {
				setIsDoingSomething(true);
				const response = await getMateriaTipoVinculo({ id: itemCrud.id });
				setIsDoingSomething(false);

				if (response.ok) {
					_itemCrud = {
						id: response.data.data.id,
						fuero: {
							id: response.data.data.id_fuero,
							label: response.data.data.descripcion_fuero,
						},
						proceso: {
							id: response.data.data.id_proceso,
							label: response.data.data.descripcion_proceso,
						},
						materia: {
							id: response.data.data.id_materia,
							id_fuero: response.data.data.id_fuero,
							label: response.data.data.descripcion_materia,
						},
						tipoVinculo: {
							id: response.data.data.id_tipo_vinculo,
							label: response.data.data.descripcion_tipo_vinculo,
						},
						fechaCreacion: response.data.data.fecha_creacion,
						nombreUsuario: response.data.data.nombre_usuario,
						apellidoUsuario: response.data.data.apellido_usuario,
						username: response.data.data.username,
					};

					setActionCrud(action);
					setItemCrud(_itemCrud);
					setOpenDialog(true);
				} else {
					setMessage({
						severity: response.messageSeverity,
						messageText: response.messageText,
					});
					setShowMessage(true);
					return;
				}
			};
			loadItem();
		} else {
			_itemCrud = {
				id: '',
				fuero: {
					id: '',
					label: '',
				},
				proceso: {
					id: '',
					label: '',
				},
				materia: {
					id: '',
					id_fuero: '',
					label: '',
				},
				tipoVinculo: {
					id: '',
					label: '',
				},
				fechaCreacion: '',
				nombreUsuario: '',
				apellidoUsuario: '',
				username: '',
			};

			setActionCrud(action);
			setItemCrud(_itemCrud);
			setOpenDialog(true);
		}
	};

	const handleDialogSave = () => {
		load();
		setOpenDialog(false);
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
	};


	//
	// ################################################################################
	//

	const loadProcesos = async (newValue) => {
		let _params = {
			idFuero: newValue?.id || valueAutoCompleteFuero?.id,
			estado: searchData.estado,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};

		setIsDoingSomething(true);
		const response = await getProcesos(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _procesos = [];

			_response.forEach((item) => {
				_procesos.push({
					id: item.id,
					id_fuero: item.id_fuero,
					label: item.descripcion,
				});
			});

			setProcesos(_procesos);
		} else {
			setProcesos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//

	// let table = data.data.table

	return (
		<>
			<Paper

				elevation={2}
			>
				<Box
					sx={{
						margin: "auto",
						width: "90%",
					}}
				>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h2>{nameItemsText}</h2>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="fuero"
									size="small"
									value={valueAutoCompleteFuero}
									onChange={handleFueroChange}
									inputValue={inputValueAutoCompleteFuero}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteFuero(newInputValue);
									}}
									options={fueros}
									renderInput={(params) => (
										<TextField {...params} label="Fuero" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="proceso"
									size="small"
									disabled={!valueAutoCompleteFuero?.id}
									value={valueAutoCompleteProceso}

									onChange={handleProcesoChange}
									inputValue={inputValueAutoCompleteProceso}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteProceso(newInputValue);
									}}
									options={procesos}
									renderInput={(params) => (
										<TextField {...params} label="Proceso" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="materia"
									size="small"
									disabled={!valueAutoCompleteProceso?.id}
									value={valueAutoCompleteMateria}
									onChange={(event, newValue) => {
										setValueAutoCompleteMateria(newValue);
										setSearchData({
											...searchData,
											idMateria:
												newValue === null ? "" : newValue.id,
										});
									}}
									inputValue={inputValueAutoCompleteMateria}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteMateria(newInputValue);
									}}
									options={materias}
									renderInput={(params) => (
										<TextField {...params} label="Materia" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="tipoVinculo"
									size="small"
									value={valueAutoCompleteTipoVinculo}
									onChange={(event, newValue) => {
										setValueAutoCompleteTipoVinculo(newValue);
										setSearchData({
											...searchData,
											idTipoVinculo:
												newValue === null ? "" : newValue.id,
										});
									}}
									inputValue={inputValueAutoCompleteTipoVinculo}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteTipoVinculo(newInputValue);
									}}
									options={tipoVinculos}
									renderInput={(params) => (
										<TextField {...params} label="Tipo Vínculo" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
						</Grid>
					</Box>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="ordenarPor-select-label">
										Ordenar por:
									</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="ordenarPor"
										label="Ordenar por:"
										id="ordenaPor"
										name="ordenarPor"
										value={searchData.ordenarPor}
										size="small"
										onChange={handleChange}
									>
										{ordenarPorOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Grid container spacing={2}>
									<Grid item xs={6}>
										<FormControl component="fieldset">
											<Box display="flex" alignItems="center" sx={{ '& .MuiFormControlLabel-root': { pl: 3 } }}>
												<Typography variant="subtitle1" component="span" sx={{ ml: 1 }}>
													Ordenar
												</Typography>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(0, Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
											</Box>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={() => handleClickActionCrud({}, "create")}
									startIcon={<AddIcon />}
								>
									Nuevo
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%", mr: 1 }}
									variant="outlined"
									size="small"
									onClick={clean}
									startIcon={<CleaningServicesIcon />}
								>
									Limpiar
								</Button>

							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={search}
									startIcon={<SearchIcon />}
								>
									Buscar
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
					</Box>
					{isDoingSomething && <LinearProgress />}


					<MUIDataTable columns={tableColumns} data={itemsCrud} options={tableOptions} />

				</Box>
			</Paper>

			{/* >>>> Dialog */}

			{openDialog && (
				<MateriaTipoVinculoDialog
					fueros={fueros}
					materias={materias}
					tipoVinculos={tipoVinculos}
					onSave={handleDialogSave}
					onClose={handleDialogClose}
					itemCrud={itemCrud}
					actionCrud={actionCrud}
					setMessage={setMessage}
					setShowMessage={setShowMessage}
				/>
			)}

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}
		</>
	);
};

export default MateriaTipoVinculoTable;
